import { ERROR_ACTION, WAIT_FOR_ACTION } from "redux-wait-for-action";

export const actionTypes = {
  SKIP_TRACE_POST_REQUEST: "SKIP_TRACE_POST_REQUEST",
  SKIP_TRACE_POST_SUCCESS: "SKIP_TRACE_POST_SUCCESS",
  SKIP_TRACE_POST_FAILURE: "SKIP_TRACE_POST_FAILURE",
};

export const actionCreators = {
  postRequest: ({ vin }) => ({
    type: actionTypes.SKIP_TRACE_POST_REQUEST,
    payload: { vin },
    [WAIT_FOR_ACTION]: actionTypes.SKIP_TRACE_POST_SUCCESS,
    [ERROR_ACTION]: actionTypes.SKIP_TRACE_POST_FAILURE,
  }),

  postSuccess: (data) => ({
    type: actionTypes.SKIP_TRACE_POST_SUCCESS,
    payload: data,          
  }),

  postFailure: (error) => ({
    type: actionTypes.SKIP_TRACE_POST_FAILURE,
    error,                  
  }),
};

export default {
  create: actionCreators,
  type: actionTypes,
};
